import { Box, Stack, Typography } from '@mui/material';

import { useUserInfo } from '@/features/users';

export const LatestWebinar = () => {
  const user = useUserInfo();
  const firstName = user?.first_name || 'there';

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return 'Good morning';
    if (hour < 18) return 'Good afternoon';
    return 'Good evening';
  };

  return (
    <Stack spacing={1}>
      <Typography fontSize={18} fontWeight={500} color="text.primary">
        {getGreeting()} {firstName}
      </Typography>
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          paddingTop: '56.25%', // 16:9 Aspect Ratio
          borderRadius: 1,
          overflow: 'hidden',
        }}
      >
        <Box
          component="iframe"
          src="https://vimeo.com/showcase/2394590/embed"
          title="Vimeo video player"
          allow="fullscreen; picture-in-picture"
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            border: 'none',
          }}
        />
      </Box>
    </Stack>
  );
};
